import typedApiRequestService from 'common/services/api/typedApiRequestService/typedApiRequestService';

import { Method } from '../http/types';

const logoutService = () =>
  typedApiRequestService({
    method: '/v1/auth/logout',
    httpMethod: Method.Post,
  });

export default logoutService;
